export const calculateNutrientSum = (values: number[]): number => {
	return values.reduce((acc, val) => {
		if (Number.isNaN(val)) return acc;
		return acc + (Number(val) || 0);
	}, 0);
};

export const formatNutrientValue = (value: number): string => {
	if (Number.isNaN(value)) return '---';
	return value.toFixed(2).replace('.', ',');
};

export const parseNutrientValue = (value: string): number => {
	const normalized = value.replace(',', '.');
	const parsed = Number.parseFloat(normalized);
	return Number.isNaN(parsed) ? 0 : parsed;
};

export const createEmptyNutrientArray = (): number[] => {
	return new Array(12).fill(Number.NaN);
};
